import { SideNav, NavBar } from "./components"
import { linksUrl } from "./constants/enum.js"
import {
  ClientMaster,
  UserMaster,
  Login,
  ClientSubscription,
  CreateUserEntry,
} from "./pages"
import { useSelector } from "react-redux"
import PrivateRoute from "./PrivateRoute" 
import { Routes, Route, useLocation, Navigate } from "react-router-dom"

function App() {
  const { isAuthenticated } = useSelector((state) => state.auth)

  const location = useLocation()

  const shouldShowSidebar = () => {
    const { pathname } = location
    return ![linksUrl.login].includes(pathname)
  }

  return (
    <div className="light">
      {shouldShowSidebar() && (
        <>
          <NavBar />
          <SideNav />
        </>
      )}

      {/* Routes */}
      <Routes>
        <Route
          path={linksUrl.login}
          element={
            !isAuthenticated ? (
              <Login />
            ) : (
              <Navigate to={linksUrl.client.clientMaster} />
            )
          }
        />
        {/* ***private routes */}

        {/* client master */}
        <Route
          path={linksUrl.client.clientMaster}
          element={
            <PrivateRoute>
              <ClientMaster />
            </PrivateRoute>
          }
        />
        <Route
          path={linksUrl.client.clientSubsciption}
          element={
            <PrivateRoute>
              <ClientSubscription/>
            </PrivateRoute>
          }
        />
       

        {/* user master */}
        <Route
          path={linksUrl.user.userMaster}
          element={
            <PrivateRoute>
              <UserMaster />
            </PrivateRoute>
          }
        />
        <Route
          path={linksUrl.user.createEntry}
          element={
            <PrivateRoute>
              <CreateUserEntry/>
            </PrivateRoute>
          }
        />
       
        
       </Routes>
    </div>
  )
}

export default App
